module.exports = __webpack_public_path__ + "img/1c.e7c9b851.svg";